import { render, staticRenderFns } from "./AddEstimateRoleDialog.vue?vue&type=template&id=41745787"
import script from "./AddEstimateRoleDialog.vue?vue&type=script&lang=js"
export * from "./AddEstimateRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports